<template>
  <v-dialog
    v-if="
      dialog &&
      ((selectedProducts.length &&
        selectedProducts.filter((x) => !x.isAdditionalProduct).length) ||
        (selectedProduct !== null &&
          !selectedProducts.length &&
          !selectedProduct.isAdditionalProduct) ||
        selectedBundle !== null)
    "
    :fullscreen="!$vuetify.breakpoint.smAndUp"
    :value="dialog"
    max-width="1000"
    @click:outside="closeDialog"
  >
    <v-card
      :disabled="loading"
      :loading="loading"
      :class="!$vuetify.breakpoint.smAndUp ? 'mobile-card' : ''"
    >
      <v-card-title class="pa-0">
        <v-toolbar elevation="0" color="var(--v-primary-opacity-12)">
          <v-icon color="primary" class="pr-2">fxt-cart</v-icon>
          <div
            :style="!$vuetify.breakpoint.smAndUp ? 'font-size:18px' : ''"
            :class="
              !$vuetify.breakpoint.smAndUp ? '' : 'title font-weight-medium'
            "
            style="color: var(--v-primary-base)"
          >
            Supert! <br v-if="!$vuetify.breakpoint.smAndUp" />
            Produktet er lagt til i handlevognen
          </div>
          <v-spacer />
          <v-btn icon @click="closeDialog">
            <v-icon color="primary">close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text class="px-5 py-5">
        <!-- <div class="pa-3">
          <div class="title">Produkter hos {{ selectedSalon.siteName }}</div>
          <div class="text-uppercase">
            {{ selectedSalon.address }}, {{ selectedSalon.postalArea }}
          </div> 

          <div class="mt-6">
            <span class="subtitle-2">Produkter</span>
            <span>
              -
              {{ cartTotalQuantity }}
              varer</span
            >
          </div>
        </div> -->
        <!-- <v-divider></v-divider> -->
        <template v-if="selectedProducts.length">
          <added-to-cart-dialog-products
            :cartItemList="selectedCartItems"
            :prods="selectedProducts"
          ></added-to-cart-dialog-products>
        </template>
        <template
          v-else-if="selectedProduct !== null && !selectedProducts.length"
        >
          <added-to-cart-dialog-product
            :cartItem="selectedCartItem"
            :product="selectedProduct"
          ></added-to-cart-dialog-product>
        </template>
        <template v-else-if="selectedBundle !== null">
          <added-to-cart-dialog-bundle
            :cartItem="selectedBundleItem"
            :product="selectedBundle"
          ></added-to-cart-dialog-bundle>
        </template>
        <RecommendationBox
          class="rec-box-add-dialog pb-4"
          :userId="this.$user.onlineSluttKundeId"
          presentation="grid"
          :itemQty="4"
          :itemType="itemType.P"
          :chainId="parseInt(this.$route.params.chainId)"
          :location="location.PRODUCT_PAGE"
          :channel="channel.Nettbutik"
          :productIds="
            selectedBundle != null ? base64Ids : [selectedProduct.idBase64]
          "
          :urlBase="urlBase"
          :cartItemsIds="cartItemIds"
          @buttonClick="addBtnAction"
          @cardClick="goToProductDetailsRec"
        >
        </RecommendationBox>
        <div class="d-flex justify-center" v-if="$vuetify.breakpoint.smAndUp">
          <div style="width: 75%">
            <v-btn
              style="font-size: 18px"
              class="mb-4 text-none"
              block
              large
              rounded
              color="primary"
              @click="closeDialog"
              >Fortsett å handle
            </v-btn>
            <v-btn
              block
              color="primary"
              class="text-none"
              large
              rounded
              outlined
              @click="closeDialog(true)"
            >
              <span style="font-size: 18px">Gå til handlekurv</span>
            </v-btn>
          </div>
        </div>
        <!-- <product-suggestions suggestion-text="Kan du være interessert i noe av dette?"></product-suggestions> -->
      </v-card-text>
      <v-card-actions v-if="!$vuetify.breakpoint.smAndUp" class="card-actions">
        <div class="d-flex justify-center" style="width: 100%">
          <div style="width: 75%">
            <v-btn
              style="font-size: 18px"
              class="mb-4 text-none"
              block
              large
              rounded
              color="primary"
              @click="closeDialog"
              >Fortsett å handle
            </v-btn>
            <v-btn
              block
              color="primary"
              class="text-none"
              large
              rounded
              outlined
              @click="closeDialog(true)"
            >
              <span style="font-size: 18px">Gå til handlekurv</span>
            </v-btn>
          </div>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ProductSuggestions from "./ProductSuggestions";
import webshopMixins from "@/components/webshop/cart/webshop.mixins";
import CoPurchaseSuggestions from "./CoPurchaseSuggestions";
import AddedToCartDialogProduct from "./ProductAddedToCartDialog/AddedToCartDialogProduct";
import AddedToCartDialogProducts from "./ProductAddedToCartDialog/AddedToCartDialogProducts";
import AddedToCartDialogBundle from "./ProductAddedToCartDialog/AddedToCartDialogBundle";
import RecommendationBox from "@fixit/v-recommendation-box";
import {
  ItemType,
  Location,
  Channel,
} from "@fixit/v-recommendation-box/src/enums";
import wrap from "@/utils/odin-guid/wrap";

export default {
  mixins: [webshopMixins],
  data() {
    return {
      loading: false,
      itemType: ItemType,
      location: Location,
      channel: Channel,
    };
  },
  components: {
    RecommendationBox,
    CoPurchaseSuggestions,
    ProductSuggestions,
    AddedToCartDialogProduct,
    AddedToCartDialogBundle,
    AddedToCartDialogProducts,
  },
  props: {
    dialog: Boolean,
  },
  methods: {
    async closeDialog(goToCart) {
      await this.$store.dispatch("webshop/set", {
        key: "addedToCartDialog",
        value: false,
      });
      await this.$store.dispatch("webshop/set", {
        key: "addedProductsToCartDialog",
        value: false,
      });
      if (goToCart === true)
        this.$router.push({
          name: "webshopChainShoppingCartClickAndCollect",
          params: {
            chainId: this.$route.params.chainId || this.$route.query.chainId,
            siteId: 0,
          },
        });
    },
    isDateAfterToday(date) {
      return (
        new Date(date.toDateString()) >= new Date(new Date().toDateString())
      );
    },
    async addBtnAction(item) {
      var link = item.urlSafe.split("/");
      var product = await this.$store.dispatch("webshop/getProductsByIds", {
        avoidCache: true,
        chainId: parseInt(this.$route.params.chainId),
        includeCampaignProducts: true,
        isBase64: true,
        productIds: [link[1]],
      });
      // await this.$store.dispatch("webshop/set", {
      //   key: "addedToCartDialog",
      //   value: false,
      // });
      this.$store.dispatch("webshop/set", {
        key: "selectedProduct",
        value: product[0],
      });
      this.addProductToSalonCart(this.salons[0]);
    },
  },
  computed: {
    items() {
      return (
        (this.selectedSalon?.siteId
          ? this.$store.getters["checkout/cartProductsBySite"](
              this.selectedSalon.siteId
            )
          : this.$store.getters["checkout/cartProducts"]) || []
      );
    },
    bundlesAvailableForCheckout() {
      return this.bundleItemsBySiteId.filter((x) =>
        this.isDateAfterToday(new Date(x.toDate))
      );
    },
    bundleItemsBySiteId() {
      return this.cartBundles.filter(
        (x) => x.siteId == this.selectedSalon.siteId
      );
    },
    productNotAvailable() {
      return (item) =>
        !item.quantity ||
        !(
          this.cartProducts
            .find((x) => x.id === item.id)
            .productDetails.inventory.find(
              (x) => x.siteId === parseInt(this.selectedSalon.siteId)
            )?.stockAmount || 0
        );
    },
    selectedCartItem() {
      return this.items.find((x) => x.id === this.selectedProduct.id);
    },
    productsAvailableForCheckout() {
      return this.cartItemsBySiteId.filter((p) => !this.productNotAvailable(p));
    },
    cartItemsBySiteId() {
      return this.cartItems.filter(
        (x) => x.siteId == this.selectedSalon.siteId
      );
    },
    cartTotalQuantity() {
      var productTotalQuantity = this.productsAvailableForCheckout.reduce(
        (total, product) => {
          return total + product.quantity;
        },
        0
      );

      var bundleTotalQuantity = this.bundlesAvailableForCheckout.reduce(
        (total, bundle) => {
          return total + bundle.quantity;
        },
        0
      );

      return productTotalQuantity + bundleTotalQuantity;
    },
    selectedCartItems() {
      var prodIds = this.selectedProducts
        .filter((x) => x != null)
        .map((x) => x.id);
      return this.cartItems.filter((x) => prodIds.includes(x.id));
    },

    selectedBundleItem() {
      return this.cartBundles.find(
        (x) => x.campaignId === this.selectedBundle?.campaignId
      );
    },

    selectedProduct() {
      return this.$store.getters["webshop/get"]("selectedProduct");
    },

    selectedBundle() {
      return this.$store.getters["webshop/get"]("selectedBundle");
    },
    base64Ids() {
      const base64 = [];
      this.selectedBundle.productIds.forEach((x) =>
        base64.push(wrap(x).Base64Guid)
      );
      return base64;
    },
  },
  created() {
    this.$eventBus.$on("close-product-added-to-cart-dialog", this.closeDialog);
  },
  destroyed() {
    this.$eventBus.$off("close-product-added-to-cart-dialog");
  },
  watch: {
    dialog(val) {
      let html = document.getElementsByTagName("HTML")[0];
      html.style.overflowY = val ? "hidden" : "auto";
      if (!val) {
        if (this.$route.name != "webshopChainProductDetails")
          this.$store.dispatch("webshop/set", {
            key: "selectedProduct",
            value: null,
          });
        this.$store.dispatch("webshop/set", {
          key: "selectedProducts",
          value: [],
        });
        if (this.$route.name != "webshopCampaignBundle") {
          this.$store.dispatch("webshop/set", {
            key: "selectedBundle",
            value: null,
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-dialog__content--active {
  z-index: 501 !important;
}

.v-card__title {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: white;
}

.v-card__text {
  color: rgba(0, 0, 0, 1) !important;
  font-size: 16px !important;
}

.mobile-card {
  position: relative;

  .card-actions {
    position: absolute;
    bottom: 0;
    width: 100%;
  }
}

.quantity__actions {
  padding: 12px 0;

  .v-icon {
    cursor: pointer;
  }

  .v-icon::after {
    background-color: transparent;
  }
}
</style>
<style lang="css">
.rec-box-add-dialog .container.grid {
  width: 100% !important;
  padding: 0;
  margin-bottom: 5px;
}
</style>
